export default "__VITE_ASSET__BKG$v_kk__"